import React, { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SiteBanner from "./SiteBanner";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <SiteBanner />
      <Navbar />
      <main className="min-h-screen">{children}</main>
      <Footer />
    </>
  );
}